module.exports = __webpack_public_path__ + "13948d4b2c7a37115ac7c297c46b6db0.png";